import { VivawalletCustomer } from "./vivawallet-customer";

export class VivawalletPaymentOrderPost {

    constructor(
        public amount: number,
        public customerTrns: string,
        public customer: VivawalletCustomer
    ){}
}
